import React from 'react';
import { useNavigate } from 'react-router-dom';
import clsx from "clsx";

const NewProjectButton = () => {

    const navigate = useNavigate();


    const createDuplicateProject = () => {
        navigate('/create_project', { state: { reason: 'duplicate' } });
    }

    const createBlankProject = () => {
        navigate('/create_project', { state: { reason: 'new' } });
    }

    return(
        <div className="dropdown">
            <button className={clsx('btn dropdown-toggle','dropdown-button')} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                New project
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <button type='button' key='newProjectButton' className={clsx('dropdown-item', 'teamSelector','styleDropDown3')} onClick={() => createDuplicateProject()}>From existing project </button>
                <button type='button' key='duplicateButton' className={clsx('dropdown-item','teamSelector','styleDropDown3')} onClick={() => createBlankProject()}> Blank project</button>
            </div>
        </div>
    )

}

export default NewProjectButton;